<template>
  <Loader v-if="loading" />
  <FailedToLoad v-else-if="error" />

  <div v-else>
    <div v-if="submissions.length === 0" class="no-submissions">
      <h2>Let's add your first submission</h2>
      <new-submission />
    </div>
    <div v-else>
      <h2>Your submissions</h2>
      <upload-modal @cancel="showUploadModal = false" v-if="showUploadModal" />
      <SubmissionGrid @addNew="showUploadModal = true" />

      <template v-if="paintovers.length > 0">
        <h2>Paintover<template v-if="paintovers.length > 1">s</template></h2>
        <image-grid :items="paintovers" />
      </template>
      <info-box v-else>
        <span class="title-large">Paintovers</span>
        <p>
          You will be able to find your paintover here after the live critique
          session.
        </p>
        <p class="italic">
          Make sure you mark a submission to be critiqued or you will miss out
          on a live critique and paintover.
        </p>
      </info-box>
    </div>
  </div>
</template>

<script>
import NewSubmission from '@/components/art-club/study/my-submissions/NewSubmission';
import SubmissionGrid from '@/components/art-club/study/my-submissions/SubmissionGrid';
import UploadModal from '@/components/art-club/study/my-submissions/UploadModal';
import Loader from '@/components/global/Loader';
import FailedToLoad from '@/components/global/FailedToLoad';
import ImageGrid from '@/components/image-grid';
import InfoBox from '@/components/app/InfoBox';

import { mapActions, mapState } from 'vuex';

export default {
  name: 'art-club-study-my-submissions',
  components: {
    NewSubmission,
    SubmissionGrid,
    UploadModal,
    Loader,
    FailedToLoad,
    ImageGrid,
    InfoBox,
  },
  data() {
    return {
      showUploadModal: false,
      failed: false,
    };
  },
  async mounted() {
    if (this.studyId === this.$route.params.id) return;
    await this.getSubmissions(this.$route.params.id);
  },
  methods: {
    ...mapActions('mySubmissions', ['getSubmissions']),
  },
  watch: {
    uploadStatus: function(newVal) {
      if (newVal === 'success') {
        this.showUploadModal = false;
      }
    },
  },
  computed: {
    ...mapState('mySubmissions', {
      submissions: state => state.submissions,
      loading: state => state.loading,
      error: state => state.error,
      studyId: state => state.studyId,
    }),
    ...mapState('study', {
      deadline: state => state.deadline,
    }),
    ...mapState('uploadSubmission', {
      uploadStatus: state => state.status,
    }),
    paintovers() {
      return this.submissions
        .filter(x => x.critiqueUrl)
        .map(x => x.critiqueUrl);
    },
  },
};
</script>

<style lang="scss" scoped>
.no-submissions {
  width: 100%;
}
</style>
